// const COS = require('cos-js-sdk-v5')
import COS from 'cos-js-sdk-v5'
import { getBaseUrl } from "@/util/config";
import axios from "axios";

// 填写自己腾讯云cos中的key和id (密钥)
// https://console.cloud.tencent.com/cam/capi
const cos = new COS({
  SecretId: 'AKIDzmJbcMozu2tTmoZ3FBpCI7fwxjDRO4Tb',
  SecretKey: 'sTptgCRP5UhcHfoiKfjWyEEzUjiRvA9s',
})


// 腾讯云COS上传文件方法  参数为file文件对象
export const uploadCOS = (file) => {
  return new Promise((resolve, reject) => {
    if (file) {
      let FormDatas = new FormData();

      FormDatas.append("file", file);

      let BASE_URL = getBaseUrl();
      axios.post(`${BASE_URL}base/upload/uploadPicture?type=record`, FormDatas, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        })
        .then(res => {
          console.log("resssssssssss", res);
          if (res.code == 0) {
            console.log("res.data", res.data);
            let { fileName, uploadPath } = res.data;
            resolve(uploadPath)
          } else {
            this.$message.error(res.message);
          }
        });
      // 执行上传操作
      // cos.putObject(
      //   {
      //     Bucket: 'git-1304113371' /* 存储桶 */,
      //     Region: 'ap-nanjing' /* 存储桶所在地域，必须字段 */,
      //     Key: file.name /* 文件名 */,
      //     StorageClass: 'STANDARD', // 上传模式, 标准模式
      //     Body: file, // 上传文件对象
      //     onProgress: (progressData) => {
      //       // 上传进度
      //       console.log(JSON.stringify(progressData))
      //     },
      //   },
      //   (err, data) => {
      //     console.log(data, 'dat的点点滴滴a');
      //     // 上传成功之后
      //     if (data.statusCode === 200) {
      //       resolve(`https://${data.Location}`)
      //     }
      //     if (err) reject(err)
      //   }
      // )
    }
  })
}
